import React from "react";
import { motion } from "framer-motion";
import LoginForm from "./components/LoginForm";

const Login = () => {
  return (
    <div className="min-h-screen flex flex-col md:flex-row items-center justify-center bg-gradient-to-bl from-[#0f172a] via-[#1e1a78] to-[#0f172a] text-white p-4 md:p-6 lg:p-8">
      <div className="w-full md:w-1/2 flex justify-center mb-6 md:mb-0">
        <img
          src="/images/valluvar-1.png"
          alt="Thiruvalluvar Line Drawing"
          className="w-3/4 md:w-4/5 lg:w-4/5 xl:w-full h-auto object-contain max-w-2xl"
        />
      </div>
      <div className="w-full md:w-1/2 flex flex-col items-center text-center md:text-left px-4 md:px-8 lg:px-12">
        <motion.h1
          className="text-3xl md:text-7xl lg:text-9xl font-bold mb-2 md:mb-4"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          குறளாட்டம்
        </motion.h1>

        <motion.h1
          className="text-lg md:text-4xl lg:text-6xl font-bold mb-4 md:mb-6 bg-gradient-to-r from-green-500 via-yellow-400 to-orange-600 bg-clip-text text-transparent"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          கொண்டாட்டம்
        </motion.h1>

        <motion.p
          className="text-base md:text-lg max-w-lg mb-6 px-4 md:px-0"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          Let us play a game of Thiruvalluvar with you.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="w-full flex justify-center"
        >
          <LoginForm />
        </motion.div>
      </div>
    </div>
  );
};

export default Login;
